import { AppModule } from '@/store/modules/app';
import { ProfessionModule } from '@/store/modules/profession';
import { ClustersModule } from '@/store/modules/clusters';
import { JobType } from '@/types/ProfessionType';

export interface ClusterRef {
  id: number
  title: string
}

// Job search filtered by one occupational field (cluster). The caller navigates to the
// jobs page itself; from the welcome page it also marks the search as started there.
export const applyClusterJobSearch = (cluster: ClusterRef, fromWelcome = false): void => {
  ProfessionModule.SetParamsDefault();
  ProfessionModule.SetJobType(JobType.search);
  ProfessionModule.SetFilter({ obj: 'cluster_id', value: cluster.id });
  ProfessionModule.SetSearchTags({ tag: 'clusterTag', value: cluster.id });
  ClustersModule.SetClusterParams({ obj: 'cluster_id', value: cluster.id });
  ClustersModule.SetProfessionTitle(cluster.title);
  AppModule.SetVisibleJobs(true);
  AppModule.SetVisibleClusterJobs(false);
  if (fromWelcome) AppModule.SET_WELCOME(true);
};

export interface JobCluster {
  id: number
  name: string
  count: number
  picture?: string
}

// Occupational fields configured for the portal (PAT) with their current job counts
export const jobClusters = (): JobCluster[] => {
  const counts = AppModule.jobCountPortal.clusters;
  return AppModule.settingPortal.clusters.map((cluster) => ({
    ...cluster,
    count: counts.find((item) => item.id === cluster.id)?.count || 0,
  }));
};

// Opening "Stellensuche" / "Stellenkatalog" from the section tabs starts from a clean search,
// only a chosen occupational field (cluster) is kept.
export const resetJobSearch = (): void => {
  const selectedClusterId = ProfessionModule.jobFilter.cluster_id;
  const selectedClusterTag = ProfessionModule.searchTags.clusterTag;

  ProfessionModule.SetParamsDefault();
  ProfessionModule.SetTagsDefault();

  if (selectedClusterId) {
    ProfessionModule.SetFilter({ obj: 'cluster_id', value: selectedClusterId });
    ProfessionModule.SetSearchTags({ tag: 'clusterTag', value: selectedClusterTag || selectedClusterId });
    ClustersModule.SetClusterParams({ obj: 'cluster_id', value: Number(selectedClusterId) });
    const selectedCluster = (AppModule.settingPortal?.clusters || []).find((x: any) => x.id === Number(selectedClusterId));
    ClustersModule.SetProfessionTitle(selectedCluster?.name || '');
  }

  AppModule.SetVisibleJobs(false);
  AppModule.SetVisibleMap(false);
};
